import { useTrail, animated, useSpring, useSprings } from "@react-spring/web";
import { cardImages, cardBackCover } from "../CardImages";
import { HubConnectionBuilder, HttpTransportType } from "@microsoft/signalr";
import OpptGameBoard from "../../assets/Game/GinRummy/images/oppoGame_board.png";
import GinGameImage from "../../assets/Game/GinRummy/images/GinGame_image.png";
import GameBoard from "../../assets/Game/GinRummy/images/userGame_board.png";
import PlayerBoard from "../../assets/Game/GinRummy/images/playerBoard.png";
import User from "../../assets/Game/GinRummy/images/user.png";
import { useNavigate } from "react-router-dom";
import ExitBtn from "../../assets/Game/GinRummy/images/Exit.png";
import DeadwoodImg from '../../assets/Game/GinRummy/images/playerName.png'
import { cloneDeep } from "lodash";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import ".././cardModule.css";
import Button from "../GinGame/Button/Button";
import { useDisplayCardsQuery } from "../../features/UserFeatures/Cards/cardsSave/CardsSlice";
import GinGameScore from "../ModalPopup/GinGameScore";
import GinGameKnock from "../ModalPopup/GinGameKnock";
import Swal from "sweetalert2";
import { useLazyGetScoreQuery, useScoreMutation } from "../../features/UserFeatures/Cards/Score/ScoreSlice";
import GinGameWinPage from "../ModalPopup/GinGameWinPage";
import Loader from "../Loader/Loader";
import { useSelector, useDispatch } from 'react-redux';
import Timer from "../CountdownTimer/Timer";
import { isNewGame, saveFirstPlayerCard, saveScore, useRejoinGameGinQuery, useSavePlayersCardForP2PMutation, useShowPlayersCardForp2pMutation, useUpdatePlayersCardP2PMutation } from "../../features/UserFeatures/Cards/cardsSave/CardsSaveSlice";

const MultiPlayerGame = () => {
  let userId = localStorage.getItem("userId");
  const [createScore] = useScoreMutation();
  // const [fetchData, scoreDataFromAPi] = useLazyGetScoreQuery();
  const [savePlayerCards] = useSavePlayersCardForP2PMutation();
  // const { dataForRejoin } = useRejoinGameGinQuery()
  // const [fetchPlayersId] = useShowPlayersCardForp2pMutation()
  // console.log("dataForRrejoin", dataForRejoin)
  const [fetchUpdateId] = useUpdatePlayersCardP2PMutation()
  const userId2 = localStorage.getItem("userId2")
  const roomIdForPlay = localStorage.getItem("roomId")
  const gameName = "GinRummy";
  const [show, setShow] = useState(false);
  const [connection, setConnection] = useState(null);
  const [cardLength, setCardLength] = useState(false);
  const [oppoCardLength, setOppoCardLength] = useState(false);
  const [deckPileNewLength, setDeckPileNewLength] = useState();
  const [deadValue, setDeadValue] = useState();
  const [oppDeadValue, setOppDeadValue] = useState();
  const [animatedI, setAnimatedI] = useState(null);
  const [animatedI2, setAnimatedI2] = useState(false);
  const [animatedI3, setAnimatedI3] = useState(false);
  const [animatedI4, setAnimatedI4] = useState(null);
  const [animatedI5, setAnimatedI5] = useState(null);
  const [animatedI6, setAnimatedI6] = useState(false);
  const [borderI, setBorderI] = useState({ i: null, style: "" });
  const [knockTrue, setKnockTrue] = useState();
  // const [playerTurn, setPlayerTurn] = useState(Math.random() >= 0.5);
  const [playerTurn, setPlayerTurn] = useState(false);
  const [message, setMessage] = useState("");
  const [roomId, setRoomId] = useState();
  const [playerMelds, setPlayerMelds] = useState();
  const [playerInitialMove, setPlayerInitialMove] = useState(true);
  const [playerScore, setPlayerScore] = useState(0);
  const [botScore, setBotScore] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showScore, setShowScore] = useState(false);
  const [showWinPage, setShowWinPage] = useState(false);
  const [shuffledCard, setShuffledCard] = useState([]);
  const [deckCard, setDeckCard] = useState([]);
  const [firstPlayerCards, setFirstPlayerCards] = useState([]);
  const [secondPlayerCard, setSecondPlayerCards] = useState([]);
  const [loading, setLoading] = useState(true)
  const [totalPlayerScore, setTotalPlayerScore] = useState()
  const [totalBotScore, setTotalBotScore] = useState()
  const [playerResponseFromApi, setPlayerResponseFromApi] = useState()
  const [botResponseFromApi, setBotResponseFromApi] = useState()
  const [knockCardData, setknockCardData] = useState()
  const [counter, setCounter] = useState(false);
  const [counter1, setCounter1] = useState(false);
  const [round, setRound] = useState(1);
  const [knock, setKnock] = useState(false)
  const [passCounter, setPassCounter] = useState(1)
  const [passDisabled, setPassDisabled] = useState(false)
  const [isFlipped, setFlipped] = useState(false);
  const [multiplayerGame, setMultiplayerGame] = useState("")
  const [roundCount, setRoundCount] = useState(0)
  const { isError } = useDisplayCardsQuery();
  const [pickedSameCard, setPickedSameCard] = useState()
  const [scoreDataFromAPi, setScoreDataFromAPI] = useState([])
  const accessToken = localStorage.getItem("token");

  const navigate = useNavigate();
  const dispatch = useDispatch()
  const firstPlayerCardsData = useSelector((state) => state.playerCardDetail);
  console.log("firstFirst", firstPlayerCardsData)
  const playersScoreData = useSelector((state) => state.playerCardDetail.isGameScore)
  const oldGame = useSelector((state) => state.playerCardDetail.newGame)
  console.log("playersScoreDataplayersScoreData", playersScoreData)
  useEffect(() => {
    console.log("oldGameoldGame", oldGame)
    setPlayerInitialMove(oldGame)
  }, [])

  // const firstPlayerCardsforShow = firstPlayerCardsData?.firstPlayerCardDetail?.list?.map((d) => d?.list)
  // // console.log("firstPlayerCardsforShow",firstPlayerCardsforShow)

  useEffect(()=>{
    dispatch(saveScore([]))
    const roomId = localStorage.getItem('roomId');
    const scoreDataa = fetch(`${process.env.REACT_APP_API_KEY}/GameScore/GetGameScore?RoomId=${roomId}`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      },
    }).then((res) => res.json())
    .then((scoreDataa)=>{

        console.log("scoreDataazzxz", scoreDataa)
        dispatch(saveScore(scoreDataa))
    })
  },[roomId])

  useEffect(() => {
    const roomId = localStorage.getItem('roomId');
    const initialMove = localStorage.getItem('intitialMove');
    if (!initialMove) {
      setPlayerInitialMove(false)
    }
    if (roomId) {
      const distributeCardsShow = fetch(`${process.env.REACT_APP_API_KEY}/GameScore/ShowPlayersCardForP2P?roomId=${roomId}&userId=${userId}&roundCount=${roundCount}`, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${accessToken}`
        },
      }).then((response) => response.json())
        .then((distributeCardsShow) => {
          console.log("distributeCardsShow", distributeCardsShow?.data)
          dispatch(saveFirstPlayerCard(distributeCardsShow))
          localStorage.setItem("userId2", distributeCardsShow?.data?.userId)
          localStorage.setItem("userName2", distributeCardsShow?.data?.userName)
          setScoreDataFromAPI(playersScoreData)
          if (distributeCardsShow?.data?.turnPlayerId == distributeCardsShow?.data?.userId) {
            setPlayerTurn(true)
          }
          else {
            setPlayerTurn(false)
          }
        })

    }
  }, [roomId, playersScoreData]);


  useEffect(() => {
    console.log("scoreDataFromAPi", scoreDataFromAPi?.data)
    setBotResponseFromApi(scoreDataFromAPi?.data?.filter((item) => item?.playerUserId != userId));
    setPlayerResponseFromApi(scoreDataFromAPi?.data?.filter((item) => item?.playerUserId == userId));
  }, [scoreDataFromAPi]);

  console.log("responseFormAPI", botResponseFromApi, playerResponseFromApi)
  useEffect(() => {
    // console.count('hit')
    const playerScoreTotal = playerResponseFromApi?.map(d => d?.score + d?.bonusScore)
    const playerScoreSum = playerScoreTotal?.reduce((accumulator, currentValue) => accumulator + currentValue)
    setTotalPlayerScore((prev) => prev = playerScoreSum)
    const botScoreTotal = botResponseFromApi?.map(d => d?.score + d?.bonusScore)
    const botScoreSum = botScoreTotal?.reduce((accumulator, currentValue) => accumulator + currentValue)
    setTotalBotScore((prev) => prev = botScoreSum)
  }, [botResponseFromApi, playerResponseFromApi])
  console.log("checkScofre", totalBotScore, "uuuuuuuuu", totalPlayerScore)

  useEffect(() => {
    const allCards = async () => {
      setShuffledCard(firstPlayerCardsData?.list.data?.deckCard);
      setDeckCard(firstPlayerCardsData?.list?.data?.openCard);
      setFirstPlayerCards(firstPlayerCardsData?.list?.data?.firstPlayerCards);
      setRoomId(firstPlayerCardsData?.list?.data?.roomId);
      saveCard(firstPlayerCardsData?.list?.data?.firstPlayerCards, firstPlayerCardsData?.list.data?.deckCard, firstPlayerCardsData?.list?.data?.openCard, firstPlayerCardsData?.list?.data?.roomId, "save", userId)
      if (firstPlayerCardsData?.list?.data?.turnPlayerId == userId) {
        setPlayerTurn(true)
      }
      else {
        setPlayerTurn(false)
      }
    }

    allCards()
    const rc = localStorage.getItem("roundCount")
    setRoundCount(Number(rc))
  }, [firstPlayerCardsData, connection])

  useEffect(() => {
    if (isError) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Session expired !",
        showConfirmButton: false,
        allowOutsideClick: false,
        footer: '<a class="btn btn-info" href=/login>Login Again</a>',
      });
    }
  }, [isError]);

  const userSprings = useSpring({
    from: {
      left: `-50vw`,
      top: `0`,
      transition: "0s ease-in-out",
      transform: "translate(-50%, 80%), rotate(0deg)",
      transform: "rotate(0deg)",
      position: "absolute",
    },

    to: {
      left: `35vw`,
      top: `30vh`,
      transition: "0.6s ease-in-out",
      transform: "translate(20%, 20%) rotate(30deg)",
      width: "10vw",
      visibility: "visible",
    },
  });

  const [oppoSprings, api] = useSprings(
    deckPileNewLength ?? 31,
    () => ({
      from: {
        left: `-50vw`,
        top: `0`,
        transition: "0s ease-in-out",
        transform: "translate(-50%, 80%), rotate(0deg)",
        transform: "rotate(0deg)",
        position: "absolute",
      },

      to: {
        left: `38vw`,
        top: `-45vh`,
        transition: "0.4s ease-in-out",
        transform: "rotate(-30deg)",
        // transform: 'translate(20%, 20%) rotate(-30deg)',
        width: "8vw",
        visibility: "visible",
      },
    }),

    []
  );

  const springs = useSpring({
    from: {
      left: `0`,
      top: `-45vh`,
      transition: "0 ease-in-out",
      transform: "rotate(0deg)",
      width: "10vw",
    },

    to: {
      left: `11vw`,
      top: `-46.5vh`,
      transition: "0.4s ease-in-out",
      transform: "rotate(0deg)",
      width: "10vw",
      borderRadius: "10px",
    },
  });

  const springsBot = useSpring({
    from: {
      left: `0`,
      top: `0`,
      transition: "0.4s ease-in-out",
      transform: "rotate(10deg)",
      width: "10vw",
    },
    to: {
      left: `11vw`,
      top: `39vh`,
      transition: "0.3s ease-in-out",
      transform: "rotate(0deg)",
      width: "10vw",
      borderRadius: "10px",
    },
  });

  const discardUserSprings = {
    left: `35vw`,
    top: `25vh`,
    transition: "0.5s ease-in-out",
    transform: "translate(20%, 100%) rotate(30deg)",
    width: "8vw",
  };

  const discardBotSprings = {
    left: `39vw`,
    top: `-47vh`,
    transition: "0.4s ease-in-out",
    transform: "rotate(-30deg)",
    width: "8vw",
  };

  let userName = localStorage.getItem("userName");
  let userName2 = localStorage.getItem("userName2");
  // start socket

  console.log("userName2userName2", userName2)
  useEffect(() => {
    try {
      const connect = new HubConnectionBuilder()
        .withUrl(`${process.env.REACT_APP_API_KEY}/gameHub`, {
          accessTokenFactory: () => accessToken,
          // skipNegotiation: true,
          transport: HttpTransportType.LongPolling,
        })
        .withAutomaticReconnect()
        .build();
      setConnection(connect);
    } catch (err) {
      console.log("invoking Error", err);
    }
  }, []);

  useEffect(() => {
    if (connection && firstPlayerCardsData && firstPlayerCards) {
      connection
        .start()
        .then(() => {
          invokeConnection();
        })
        .catch((error) => console.log(error));
    }
    getData();
  }, [connection, firstPlayerCardsData, firstPlayerCards]);

  async function invokeConnection() {
    async function start() {
      try {
        await connection.start();
        console.log("SignalR Connected.");
      } catch (err) {
        console.log(err);
        setTimeout(start, 5000);
      }
    };

    connection.onclose(async () => {
      await start();
    });
    try {
      // const joinGroupData = await connection.invoke("JoinGroup", userId, roomId);
      // console.log("joinGroupData", joinGroupData)
      console.log("calleddddddddddd")
      const melds = await connection.invoke("GetGinMeldsFromCard", firstPlayerCards, roomId);
      console.log("meldsmelds", melds)
      setFirstPlayerCards(melds?.data?.data.playerCards)
      setPlayerMelds(melds?.data?.data);
      setDeadValue(melds?.data?.data?.deadwood);
      localStorage.setItem('deadwood', melds?.data?.data?.deadwood)


    }

    catch (err) {
      console.error("Error invoking CardDistributed:" + err);
    }
  }

  const getData = async () => {
    let Meldstyle = [];
    if (connection) {
      if (playerMelds?.playerMeldCard) {
        playerMelds?.playerMeldCard?.forEach((item, index) => {
          Meldstyle?.push({ i: index, style: "type1" });
        });
        setBorderI(Meldstyle);
      }
      Meldstyle = [];
    }
  };

  const trail = useTrail(oppoCardLength ? 11 : 10, {
    transform: show ? "translateX(0)" : "translateX(-100px)",
    opacity: show ? 1 : 0,
    config: { duration: 150 },
    from: { transform: "translateX(-100%)" },
  });

  const trail2 = useTrail(cardLength ? 11 : 10, {
    transform: show ? "translateX(0)" : "translateX(-100px)",
    opacity: show ? 1 : 0,
    display: show ? "block" : "none",
    config: { duration: 150 },
    from: { display: "none" },
  });

  const trail3 = useTrail(deckPileNewLength ?? 31, {
    transform: show ? "translateX(0)" : "translateX(-100px)",
    opacity: show ? 1 : 0,
    display: show ? "block" : "none",
    config: { duration: 150 },
  });

  const Card = ({ card, style }) => (
    <animated.div style={style} className="card">
      <img src={card} />
    </animated.div>
  );

  function getSRC(cardN, cardS) {
    if (cardN && cardS) {
      const url = cardImages.find((o) => o.cardName.replace(/ /g, '') == cardN.replace(/ /g, '') && o.cardSuit.replace(/ /g, '') == cardS.replace(/ /g, ''));
      return url?.img;
    }
  }

  const passTurn = () => {
    setMessage("pass");
    setPlayerTurn(true);
  };

  useEffect(() => {
    setShow(true);
  }, [playerTurn]);

  useEffect(() => {
    setAnimatedI4("");
    setAnimatedI2("");
    setAnimatedI("");
    setAnimatedI3(false);
    setAnimatedI5("");
    setAnimatedI6(false);
    setPlayerMelds([]);
    setDeadValue(deadValue);
  }, [firstPlayerCards,]);

  const exitGame = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Want to exit!",
      icon: "warning",
      cancelButtonColor: "#DD6B55",
      confirmButtonColor: "#DD6B55",
      showConfirmButton: true,
      showDenyButton: true,
      denyButtonText: "Cancel",
      confirmButtonText: "Exit",
      focusCancel: true,
    }).then(function ({ isConfirmed }) {
      if (isConfirmed) {
        dispatch(isNewGame(playerInitialMove))
        dispatch(saveScore([]))
        navigate("/gingame");
        localStorage.removeItem('intitialMove')
        localStorage.removeItem('userName2')
        localStorage.removeItem('userId2')
        localStorage.removeItem('roundCount')
        localStorage.removeItem('deadwood')
        localStorage.removeItem('roomId')

      } else {
        console.log("no");
      }
    });

  };

  useEffect(() => {
    if (firstPlayerCards) { setLoading(false) }
  }, [firstPlayerCards])

  useEffect(() => {
    if (connection) {
      connection.on("throwCardByPlayer", function (userId, currentCard, data) {
        console.log("dataFromThrowCard", userId, currentCard, data);
        // setDeckCard({});
        opponentTurn(data, currentCard)

      });
    }
  }, [connection])

  const opponentTurn = async (data, currentCard) => {
    console.log("cardevent", data)
    if (data?.position == "right") {
      // setAnimatedI5(deckCard[deckCard.length - 1]?.id);
      setAnimatedI5(currentCard?.id);
      // const ele = deckCard[deckCard.length - 1];
      // console.log("elementForOppnentDisacardedTurn", ele)
      setOppoCardLength(true);
      // const pickedCard = cloneDeep(firstPlayerCards);
      setTimeout(async () => {
        setDeckCard((current) => current?.filter((item) => item?.id !== currentCard?.id));
        //   // pickedCard.push(ele);
        //   // const cardsforPlayerS = await connection.invoke("GetGinMeldsFromCard", pickedCard, roomId);
        //   // console.log("cardsforPlayerS", cardsforPlayerS?.data?.data)
        //   // setFirstPlayerCards(cardsforPlayerS?.data?.data?.playerCards);
      }, 400);
      // console.log("pickedCard", pickedCard)
      setCardLength(false);
      localStorage.removeItem("intitialMove")
    }
    else if (data?.position == "left") {
      setCounter(!counter);
      console.log("leftFirstPlayerCardsw", firstPlayerCards)
      setOppoCardLength(true);
      setCardLength(false);
      setShuffledCard((current) => current.filter((item) => item.id !== currentCard?.id));

    }
    else if (data?.cardAction == "pass") {
      console.log("cardAction", data, passCounter)
      setPlayerTurn(true);
      // if (data?.passDisabled == false) {
      //   console.log("pAAAASSSS")
      //   // setPassDisabled(true)
      //   data.passDisabled = true
      //   setPlayerInitialMove(false);
      // }
      // else {
      //   console.log("NOOOOOO")
      //   setPlayerInitialMove(true);
      // }
      console.log("passCounterCheck", passCounter)

      // setPlayerInitialMove(true);
      setPassCounter(passCounter + 1)
    }

    else if (data.cardAction == "knock") {
      console.log("knockKnockdsdsds", data)
      console.log("scoreData", scoreData)
      setMultiplayerGame("multiplayer_Game")
      setOppDeadValue(Number(data?.deadwood))
      knockReverse(Number(data?.deadwood))
      // const rc = localStorage.getItem("roundCount")
      localStorage.setItem("roundCount", Number(data.roundCount))
      console.log("valueeeessss1", oppDeadValue, deadValue)

      setTimeout(() => {
        setShow(false);
        setShowModal(true);
        setShuffledCard([]);
        setKnock(true)
        setDeckCard([]);
        setFirstPlayerCards([]);
        setSecondPlayerCards([]);
      }, 2000)
    }

    else if (data?.cardAction == "knockReverse") {
      console.log("knockKnock", data)
      console.log("scoreData", scoreData)
      setOppDeadValue(Number(data?.deadwood))
      knockBtn(data.deadwood)
    }

    else {
      setCounter1(!counter1);
      setPlayerInitialMove(false);
      setOppoCardLength(false);
      setAnimatedI6(true);
      setDeckCard((prevState) => [...prevState, currentCard]);
      setTimeout(() => {
        setPlayerTurn(true);
      }, 1000);
    }
    console.log("dataPosition", data?.position, currentCard)
  }

  console.log("opponentDeadValue", oppDeadValue)
  console.log("countCpunt3", roundCount)
  const cardsDataThrow = {
    position: "bottom",
  }

  const knockReverse = async (deadv) => {
    const dv = localStorage.getItem('deadwood')
    const obj = {
      cardAction: "knockReverse",
      deadwood: dv,

    }
    console.log("deadValueOn", dv)
    // setRoundCount(roundCount + 1)
    playerScoreData(deadv, "knockReverse")
    // localStorage.setItem("count", roundCount + 1)
    connection.invoke("ThrowCardByPlayer", {}, userId2, obj)
  }

  console.log("roundCount11", roundCount)
  console.log("userIddd", userId)

  const handler = (index, id) => {
    try {
      if (firstPlayerCards.length == 11) {
        console.log("indexComing", index, id)
        const element = firstPlayerCards[index];
        console.log("ele3mnt", element)
        if (pickedSameCard === element?.id) {
          console.log("yessssssssdsd")
          return false;
        }
        setAnimatedI(id);
        setTimeout(async () => {
          setCardLength(false);
          setDeckCard([...deckCard, element]);
          let updatedDeckCards = []
          updatedDeckCards = ([...deckCard, element])
          let discardedCard = cloneDeep(firstPlayerCards);
          // setFirstPlayerCards((current) => current.filter((item) => item.id !== id));
          // setDeckCard((current) => current.filter((item) => item.id !== ele.id));
          discardedCard = discardedCard?.filter((item, i) => index != i);
          console.log("discardedCardhandler", discardedCard)
          // discardedCard?.deckCard?.push(element);
          // setCardData(discardedCard);
          const deadWoodPlayer = await connection.invoke("GetGinMeldsFromCard", discardedCard, roomId);
          console.log("cardsTOSHOW2", deadWoodPlayer?.data?.data)
          connection.invoke("ThrowCardByPlayer", element, userId2, cardsDataThrow)
          setPlayerMelds(deadWoodPlayer?.data?.data);
          setDeadValue(deadWoodPlayer?.data?.data?.deadwood);
          localStorage.setItem('deadwood', deadWoodPlayer?.data?.data?.deadwood)
          setFirstPlayerCards(deadWoodPlayer?.data?.data?.playerCards)
          // knockCardData?.cardIndex ? setPlayerTurn(true) : 
          setPlayerTurn(false)
          // setStart(false);
          saveCard(deadWoodPlayer?.data?.data?.playerCards, shuffledCard, updatedDeckCards, roomId, "update", userId)
          setPickedSameCard()
          // dispatch(isNewGame(playerInitialMove))
        }, 300);
      } else {
        return false;
      }
    }
    catch (err) {
      console.log("error to throw card", err)
    }
  };
  const deckCardData = {
    position: "left"
  }


  // Left one Cards
  const deckPileHandler = async (id) => {
    try {
      const picked_card = cloneDeep(firstPlayerCards);
      const ele = shuffledCard[shuffledCard.length - 1];
      const selectedShuffledCard = shuffledCard.filter((item) => item.id !== ele.id)
      if (firstPlayerCards?.length == 10 && !playerInitialMove) {
        setAnimatedI2(id);
        setFlipped(true);
        setTimeout(async () => {
          setShuffledCard((current) => current.filter((item) => item.id !== ele.id));
          setCardLength(true);
          picked_card.push(ele);
          const discardedCards = await connection.invoke("GetGinMeldsFromCard", picked_card, roomId);
          setknockCardData(discardedCards?.data?.data?.knockCard)
          console.log("cardsTOSHOW1", discardedCards?.data?.data)
          connection.invoke("ThrowCardByPlayer", ele, userId2, deckCardData)
          setFirstPlayerCards(discardedCards?.data?.data?.playerCards);
          const deckPileLength = picked_card?.length - 1;
          setDeckPileNewLength(deckPileLength);
          setDeadValue(discardedCards?.data?.data?.deadwood);
          localStorage.setItem('deadwood', discardedCards?.data?.data?.deadwood)
          setPlayerMelds(discardedCards?.data?.data);
          saveCard(discardedCards?.data?.data.playerCards, selectedShuffledCard, deckCard, roomId, "update", userId)
          setFlipped(false);
          setAnimatedI2(null);

        }, 600);
      } else {
        return false;
      }
    }
    catch (err) {
      console.log("error to pick card", err)
    }
  };


  const discardedCardData = {
    position: "right",
    cardAction: "thrown",
    FplayerTurn: false,

  }
  // right userdeck card discard function************
  const discardedPileHandler = async (id) => {
    try {
      setPlayerInitialMove(false);
      setCardLength(true);
      if (firstPlayerCards.length == 10) {

        const ele = deckCard[deckCard.length - 1];
        setAnimatedI4(id);
        const picked_card = cloneDeep(firstPlayerCards);
        setTimeout(async () => {

          const selectedDeckCard = deckCard?.filter((item) => item.id !== ele.id)
          console.log("selectedDeckCard", selectedDeckCard)
          setPickedSameCard(ele?.id)
          setDeckCard((current) => current.filter((item) => item.id !== ele.id));
          // setFirstPlayerCards([...firstPlayerCards, ele]);
          // picked_card.deckCard = picked_card.deckCard.slice(0, picked_card.deckCard.length - 1);
          picked_card.push(ele);
          console.log("eleeleele", ele)
          const discardedCards = await connection.invoke("GetGinMeldsFromCard", picked_card, roomId);
          console.log("cardsTOSHOW", discardedCards?.data?.data)
          setknockCardData(discardedCards?.data?.data?.knockCard)
          connection.invoke("ThrowCardByPlayer", ele, userId2, discardedCardData)

          setFirstPlayerCards(discardedCards?.data?.data.playerCards);
          setDeadValue(discardedCards?.data?.data?.deadwood);
          localStorage.setItem('deadwood', discardedCards?.data?.data?.deadwood)
          setPlayerMelds(discardedCards?.data?.data);
          saveCard(discardedCards?.data?.data?.playerCards, shuffledCard, selectedDeckCard, roomId, "update", userId)
          localStorage.removeItem("intitialMove")
        }, 400);
      }
    }
    catch (err) {
      console.log("error while pick card", err)
    }
  };
  console.log("pickedSameCard", pickedSameCard)
  const saveCard = async (firstP, shuffledP, deckP, roomKey, type, userId) => {
    try {
      console.log("roooosososos", roomKey)
      const firstPlayerCardsId = firstP?.map((d) => d?.id)
      const openedCardId = deckP?.map(d => d?.id)
      const deckCardsId = shuffledP?.map(d => d?.id)
      const apiResponse = async () => {
        const transformedData = {
          roomId: roomKey,
          userId: userId,
          playerCard: firstPlayerCardsId?.join(','),
          deckCard: deckCardsId?.join(','),
          openCard: openedCardId?.join(','),
          player: "",
          roundCount: roundCount,
          turnPlayer: userId2,
          id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
          createdDate: new Date(),
          createdBy: "",
          modifiedDate: new Date(),
          isDeleted: false,
          isActive: true,
          deletedOn: new Date(),
          modifiedBy: "",
        };

        if (type == "save") {
          console.log("saveDataTransformed", transformedData)
          await savePlayerCards(transformedData)
        } else {
          const updateData = await fetchUpdateId(transformedData)
          console.log("updateData", updateData)
        }
      }
      apiResponse()
    }
    catch (err) {
      console.log("error on save card", err)
    }
  }

  useEffect(() => {
    setAnimatedI3(true);
  }, [counter]);

  const dataToPass = {
    cardAction: "pass",
    passDisabled: passDisabled,
  }
  const passhandler = () => {
    setPlayerTurn(false);
    console.log("passCounterCheck1", passCounter)
    setPlayerInitialMove(false);
    setPassDisabled(true)
    // dataToPass.passDisabled = false
    setPassCounter(passCounter + 1)
    console.log("dataToPass", dataToPass)
    connection.invoke("ThrowCardByPlayer", {}, userId2, dataToPass)
  };

  async function fetchData() {
    // console.log("roomidForfetchScoreData", roomId)
    const roomId = localStorage.getItem("roomId")
    const scoreDataa = await fetch(`${process.env.REACT_APP_API_KEY}/GameScore/GetGameScore?RoomId=${roomId}`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      },
    }).then((res) => res.json())
      .then((scoreDataa) => {
        dispatch(saveScore(scoreDataa))
      })
    console.log("scoreDataa", scoreDataa)
    setScoreDataFromAPI(scoreDataa)
  }
  console.log("scoreDataaFetched", scoreDataFromAPi)
  const gameNames = {
    RoomId: roomId,
    GameName: '', //GinRummy
    UserId1: userId,
    UserName1: userName,
    UserId2: userId2,
    UserName2: userName2,
    RoundCount: roundCount

  };
  const knockBtn1 = async () => {
    try {
      setPlayerMelds([]);
      const rc = localStorage.getItem("roundCount")
      localStorage.setItem("roundCount", Number(rc) + 1)
      const dataToKnock1 = {
        cardAction: "knock",
        deadwood: deadValue,
        roundCount: Number(rc) + 1
      }
      setMultiplayerGame("multiplayer_Game")
      setRoundCount(roundCount + 1);
      await connection.invoke("ThrowCardByPlayer", {}, userId2, dataToKnock1)
      const rid = localStorage.getItem("roomId")
      gameNames.RoundCount = Number(rc) + 1
      const data = await connection.invoke("CardDistributionByRound", roomId, Number(rc) + 1);

    }
    catch (err) {
      console.log("error on knock button", err)
    }

  }

  const scoreData = [
    {
      roomId: roomId,
      gameName: gameName,
      playerUserId: userId, // Mention UserId
      round: "knock",
      score: 0,
      bonusScore: 0,
      gameRound: roundCount,
    },
    {
      roomId: roomId,
      gameName: gameName,
      playerUserId: userId2, // Mention Bot Id
      round: "knock",
      score: 0,
      bonusScore: 0,
      gameRound: roundCount,
    },
  ];
  const playerScoreData = async (oppdeadV, type) => {
    const rc = localStorage.getItem("roundCount")
    console.log("roundCountroundCount", rc)
    try {
      const deadValueP = localStorage.getItem("deadwood")
      scoreData[0].bonusScore = 0;
      scoreData[0].score = 0;
      scoreData[1].bonusScore = 0;
      scoreData[1].score = 0;
      scoreData[0].gameRound = Number(rc)
      scoreData[1].gameRound = Number(rc)
      console.log("valueeeessss", Number(oppdeadV), deadValueP)
      const difference = Number(oppdeadV) - deadValueP;
      console.log("difference", difference)
      if (difference < 0) {
        console.log("in if 1", difference)
        scoreData[0].score = 0
        scoreData[1].score = 0
        scoreData[1].score = Math.abs(difference);
        scoreData[1].bonusScore = 25;
        setPlayerScore({ score: 0, undercut: 0 });
        // setBotScore({ score: difference, undercut: 25});
        setBotScore({ score: Math.abs(difference), undercut: scoreData[1].bonusScore = 25 });
        console.log("typeeeeeee", type)
        if (type == "knockReverse") {
          console.log("calledddddddddddddddd")
          // normal called when userdeadwood < aganstPlayerDeadwood && called when user has 0 deadwood

          if (oppdeadV == 0) {
            console.log("cons", deadValueP)
            setBotScore({ score: Math.abs(difference), gin: scoreData[1].bonusScore });
          }
          else {
            scoreData[1].bonusScore = 0;
            setBotScore({ score: Math.abs(difference), undercut: scoreData[1].bonusScore });
          }
        }

      } else if ((difference == 0)) {
        console.log("in if 2")
        scoreData[0].score = 0;
        scoreData[1].score = 0;
        scoreData[0].bonusScore = 0;
        scoreData[1].bonusScore = 0;
        setPlayerScore({ score: 0, undercut: 0 });
        setBotScore({ score: 0, undercut: 0 });
      }
      else if (deadValueP == 0) {
        console.log("in if dvp")
        scoreData[0].score = Math.abs(difference);
        scoreData[1].score = 0;
        scoreData[0].bonusScore = 25;
        scoreData[1].bonusScore = 0;
        setPlayerScore({ score: scoreData[0].score, gin: scoreData[0].bonusScore });
        setBotScore({ score: 0, undercut: 0 });
      }

      // else if (playerMelds.length == 11) {
      //   console.log("in if 3 plm")
      //   scoreData[0].score = Math.abs(difference);
      //   scoreData[1].score = 0;
      //   scoreData[0].bonusScore = 50;
      //   scoreData[1].bonusScore = 0;
      //   setPlayerScore({ score: scoreData[0].score, bigGin: scoreData[0].bonusScore });
      //   setBotScore({ score: 0, undercut: 0 });
      // }

      else {
        console.log("in if else")
        console.log("diffififififif", difference)
        scoreData[0].score = Math.abs(difference);
        scoreData[0].bonusScore = 25
        scoreData[1].bonusScore = 0
        setPlayerScore({ score: scoreData[0].score, undercut: 0 });
        setBotScore({ score: 0, undercut: 0 });

        if (type == "knockReverse") {
          setPlayerScore({ score: Math.abs(difference), undercut: scoreData[0].bonusScore });
        }
      }
      console.log("scoreDataAfterKnock", scoreData)
      if (type == "knockReverse") {
        console.log("createScoreRescreateScoreRes1")
        const createScoreRes = await createScore(scoreData);
        console.log("createScoreRescreateScoreRes", createScoreRes)
        setMultiplayerGame("multiplayer_Game")
      }
      await fetchData()
    }
    catch (err) {
      console.log("error in player score", err)
    }
  }

  const knockBtn = async (oppdeadV) => {
    console.log("knockCardData11", knockCardData)
    setPlayerTurn(false);
    playerScoreData(oppdeadV, "knock")
    console.log("scoreData", scoreData)
    // setBotScore({ score: scoreData[1].score, undercut: scoreData[1].bonusScore });
    // setRoundCount(roundCount + 1);
    setTimeout(() => {
      setShowModal(true);
      setShow(false);
      setShuffledCard([]);
      setKnock(true)
      setDeckCard([]);
      setFirstPlayerCards([]);
      setSecondPlayerCards([]);
    }, 2000)

    // setCardData([])
  };
  console.log("countCpunt", roundCount)

  const continueButton1 = async (e) => {
    await fetchData()
    e.preventDefault()
    const rc = localStorage.getItem("roundCount")
    const rid = localStorage.getItem("roomId")
    gameNames.RoundCount = Number(rc)
    const queryParams = {
      rId: roomId,
      round: rc
    }
    console.log("data for Insert", rid, "------", userId, "-----", rc)
    const distributeCardsShow = await fetch(`${process.env.REACT_APP_API_KEY}/GameScore/ShowPlayersCardForP2P?roomId=${rid}&userId=${userId}&roundCount=${rc}`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      },
    }).then((res) => res.json())
    console.log("sfcoeData", distributeCardsShow)
    if (distributeCardsShow?.data?.turnPlayerId == userId) {
      setPlayerTurn(true)
    }
    else {
      setPlayerTurn(false)
    }
    dispatch(saveFirstPlayerCard(distributeCardsShow))
    console.log("checkPlayerTurn", distributeCardsShow?.data?.turnPlayerId == userId, distributeCardsShow?.data?.turnPlayerId)
    try {
      const melds = await connection.invoke("GetGinMeldsFromCard", distributeCardsShow?.data?.firstPlayerCards, roomId);
      console.log("meldsmelds", melds)
      setFirstPlayerCards(melds?.data?.data.playerCards)
      setPlayerMelds(melds?.data?.data);
      setDeadValue(melds?.data?.data?.deadwood);
      localStorage.setItem('deadwood', melds?.data?.data?.deadwood)
    }
    catch (err) {
      console.log(err)
    }
    setPlayerInitialMove(true);
    setShowModal(false);
    setShow(true);
    setCardLength(false)
  };


  const getTimeout = (s) => {
    // console.log("s",s)

    if (s == 0) {
      // setPlayerTurn(false)
    }
  }

  const scoreBtn = async () => {
    console.log("callleedd")
    setShowScore(true);
  };





  ///////////////////////// Player online/offline status code start here /////////////////////////
  // listening whether the network comes online
  window.addEventListener("online", (event) => {
    Swal.fire({
      icon: "Success",
      title: "Welcome Back",
      text: "Your network is online again!",
      showConfirmButton: true,
      allowOutsideClick: false,
    });
    console.log("Your network is online again");
  });

  // listening whether the network goes offline
  window.addEventListener("offline", (event) => {

    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "You network connection is lost!",
      showConfirmButton: false,
      allowOutsideClick: false,
      footer: '<a class="btn btn-info" href=/login>Login Again</a>',
    });

    console.log("You network connection is lost");
  });

  // Check the current status of network
  console.log(window.navigator.onLine); // true
  ///////////////////////// Player online/offline status code ends here /////////////////////////



  return (
    <>
      {loading ? <Loader /> : <div className="ginGamePage d-flex">
        <div className="leftSection">
          <div className="pageControl">
            {/* <Link to="/gingame" className='btn-container border-0 bg-transparent'>
            <img src={ExitBtn} className="img-fluid" alt="toggle image" />
</Link> */}
            <button className="btn toggleBtn" >
              {/* <img src={ToggleButton} className="img-fluid" alt="toggle image" /> */}
              <img src={ExitBtn} className="img-fluid" alt="toggle image" onClick={exitGame} />
              {/* <img src={ExitBtn} className="img-fluid" alt="toggle image" onClick={scoreBtn} /> */}
            </button>
            {/* <button onClick={(e)=>continueButton1(e)}>send message</button> */}
          </div>

          <div className="userInfo">
            <div className="userProfile">
              <img src={PlayerBoard} className="img-fluid" alt="" />
              <div className="userImage">
                <img src={User} className="img-fluid" alt="" />
                {playerTurn && !showModal && <Timer getTimer={(s) => getTimeout(s)} />}
              </div>
              <div className="userName text-capitalize">
                <span>{userName}</span>
              </div>

              <div className="playerScore">
                <img src={PlayerBoard} className="img-fluid" alt="" />
                <div className="scoreCard">
                  {console.log("scoreAfterExit", totalPlayerScore, totalBotScore)}
                  <p className="score">{totalPlayerScore ? totalPlayerScore : 0}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="game-board">
          <div className="card-container-opponent ">
            <div className="opptGameBoard text-center w-100">
              <img src={OpptGameBoard} className="img-fluid" alt="" />
            </div>
            <div className={oppoCardLength ? `pickedOpponentCards` : `opponentCards`}>
              {firstPlayerCards &&
                trail?.map(({ transform, opacity }, index) => (
                  <animated.img
                    id={secondPlayerCard[index]?.id}
                    src={cardBackCover[0]?.front}
                    // src={getSRC(secondPlayerCard[index]?.cardName, secondPlayerCard[index]?.cardSuit)}
                    style={
                      animatedI6 && index == 9
                        ? springsBot
                        : { opacity, borderRadius: "10px", position: "absolute", left: `calc(10vw * ${oppoCardLength ? index / 2.32 : index / 2.12} - 50vw/2)` }
                    }
                    className={`card opponent-card-${index + 1}`}
                  />
                ))}
            </div>
          </div>
          <div className="middle-container">
            <div className="card-stack" style={{ position: "relative" }}>
              {shuffledCard &&
                trail3.map(({ transform, opacity, display }, index) => (
                  // FOR MIDDLE LEFT ONE
                  <animated.img
                    className={`card stack-card-${index + 1}`}
                    style={
                      animatedI2 == shuffledCard[index]
                        ? userSprings
                        : animatedI3 && index == 0
                          ? oppoSprings[index]
                          : { opacity, position: "absolute", transform: `translate(-${(index * 6) / 4}px, -${(index * 6) / 4}px)`, borderRadius: "10px" }
                    }
                    // src={cardBackCover[index]?.front}
                    src={isFlipped && animatedI2?.id == shuffledCard[index]?.id ? getSRC(shuffledCard[shuffledCard.length - 1]?.cardName, shuffledCard[shuffledCard.length - 1]?.cardSuit) : cardBackCover[index]?.front}
                    onClick={playerTurn ? () => deckPileHandler(shuffledCard[index]) : () => false}
                  />
                ))}
            </div>

            <div className="gameImage">
              <div className={!playerTurn ? "d-block oppoTurn mb-3" : "d-none oppoTurn mb-3"}>
                <p className="mb-0">{userName2} Turn</p>
              </div>
              <img src={GinGameImage} className="img-fluid" alt="" />
              <div className={playerTurn ? "d-block oppoTurn mt-3 text-nowrap" : "d-none oppoTurn mt-3 text-nowrap"}>
                {playerInitialMove ? (
                  <p className="mb-0">Want to take the upcard? </p>
                ) : (
                  <p className="mb-0">Your Turn {firstPlayerCards?.length == 11 ? "Throw" : "Pick"} a Card.</p>
                )}
              </div>
            </div>

            {/* FOR MIDDLE RIGHT ONE */}
            <div className="discarded-card">
              {deckCard && deckCard.length > 0 &&
                deckCard?.map((item, index) => {
                  return (
                    <img
                      src={getSRC(item?.cardName, item?.cardSuit)}
                      style={
                        animatedI4 == item?.id
                          ? discardUserSprings
                          : animatedI5 == item?.id
                            ? discardBotSprings
                            : { position: "absolute", top: `60%`, borderRadius: "10px" }
                      }
                      alt=""
                      onClick={playerTurn ? () => discardedPileHandler(item.id) : () => false}
                    />
                  );
                })}
            </div>
          </div>

          <div className="bottomCard-container" style={{ display: "flex" }}>
            <div className="gameBoard text-center w-100">
              <img src={GameBoard} className="img-fluid" alt="" />
            </div>
            <div className={cardLength ? `pickedUserCards` : `userCards`}>
              {firstPlayerCards &&
                firstPlayerCards?.length &&
                trail2.map(({ transform, opacity, key }, index) => (
                  // LAST ROW
                  <animated.img
                    key={key}
                    id={firstPlayerCards[index]?.id}
                    style={
                      animatedI == firstPlayerCards[index]?.id
                        ? springs
                        : { opacity, borderRadius: "10px", position: "absolute", left: `calc(10vw * ${cardLength ? index / 2.32 : index / 2.12} - 50vw/2)` }
                    }
                    className={borderI[index]?.i == index ? `meld-${borderI[index].style} card` : "card"}
                    src={getSRC(firstPlayerCards[index]?.cardName, firstPlayerCards[index]?.cardSuit)}
                    onClick={playerTurn ? () => handler(index, firstPlayerCards[index]?.id) : () => false}
                  />
                ))}
            </div>
          </div>
        </div>
        {showModal &&
          <GinGameKnock
            totalBotScore={totalBotScore}
            totalPlayerScore={totalPlayerScore}
            continueButton={continueButton1}
            showModal={showModal}
            botDeadValue={oppDeadValue}
            deadValue={deadValue}
            // knockTrue={knockTrue}
            multiplayerGame={multiplayerGame}
            // setShow={setShow}
            playerScore={playerScore}
            botScore={botScore}

          />}

        {showScore && <GinGameScore showScore={showScore} setShowScore={setShowScore} setTotalPlayerScore={setTotalPlayerScore}
          setTotalBotScore={setTotalBotScore} botResponseFromApi={botResponseFromApi} playerResponseFromApi={playerResponseFromApi}
          totalPlayerScore={totalPlayerScore} totalBotScore={totalBotScore}
        />}
        {showWinPage && <GinGameWinPage showWinPage={showWinPage} setShowWinPage={setShowWinPage} multiplayerGame={multiplayerGame} />}

        <div className="rightSection">
          <div className="opponentInfo">
            <div className={playerTurn ? "d-none" : "d-block"}>
              <p className={message ? "playerPass" : "oppo Pass"}>{message}</p>
            </div>

            <div className="userProfile">
              <img src={PlayerBoard} className="img-fluid" alt="" />
              <div className="userImage">
                <img src={User} className="img-fluid" alt="" />
                {!playerTurn && !showModal && <Timer getTimer={(s) => getTimeout(s)} />}
              </div>
              <div className="userName">
                <span>{userName2}</span>
              </div>

              <div className="playerScore">
                <img src={PlayerBoard} className="img-fluid" alt="" />
                <div className="scoreCard">
                  {/* <p className="score text-muted">##</p> */}
                  <p className="score">{totalBotScore ? totalBotScore : 0}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="deadwood">
            <div className="gameButtons">
              {/* <div className={deadValue <= 60 ? "d-block" : "d-none"}>{playerTurn && knockCardData?.cardName && <Button onClick={knockBtn} btnName="Knock" />}</div> */}
              {/* {playerTurn && knockCardData?.cardName && <Button onClick={() => knockBtn1()} btnName="Knock" />} */}
              {/* <div className={deadValue <= 10 ? "d-block" : "d-none"}>
                {playerTurn && knockCardData?.cardName && <Button onClick={() => knockBtn1()} btnName="Knock" />}

              </div> */}

              <div className={deadValue <= 10 ? "d-block" : "d-none"}>
                {playerTurn && <Button onClick={() => knockBtn1()} btnName="Knock" />}
              </div>
              {playerTurn && roundCount >= 1 && <Button btnName="Score" onClick={scoreBtn} />}
            </div>
            {playerTurn && playerInitialMove && <Button btnName="Pass" onClick={passhandler} />}

            <div className="deadwoodBoard">
              <Row className="customRow">
                <Col xs={12} className="text-center">
                  <div className="deadwoodHeader">
                    <img src={DeadwoodImg} className="img-fluid" alt="Deadwood" />
                    <span>Deadwood</span>
                  </div>
                </Col>
                <Col xs={6} className="text-center">
                  <div className="currDeadwood">
                    <span>{deadValue}</span>
                  </div>
                </Col>
                <Col xs={6} className="text-center">
                  <div className="currDeadwood">{deadValue <= 10 ? <span style={{ opacity: 1 }}>10</span> : <span style={{ opacity: 0.5 }}>10</span>}</div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>}
    </>
  );
};

export default MultiPlayerGame;

